import React from 'react';
import './style.scss';
import { Footer, MouseRing, Navbar } from '../../components';
import { ServiceHero, WebDevelopmentDetails } from '../../layout';
import webdesignVideo from '../../assets/video/web-development-video.mp4';


const Index = () => {
    return (
        <div className='root'>
            <MouseRing />
            <Navbar />
            <ServiceHero videoUrl={webdesignVideo} />
            <WebDevelopmentDetails />
            <Footer />
            <div className='home__main'>
            </div>
        </div>
    )
}

export default Index